import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import templates from './slices/templateSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        templates,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
